module.exports = __webpack_public_path__ + "static/media/banner.caea352a.jpg";